import { gql } from '@apollo/client';

export const fetchDirectMatchesForSearchInPPC = gql`
  query fetchDirectMatchesForSearchInPPC($query: String, $filterOptions: [FilterOption]) {
    searchForDirectMatch(query: $query, filterOptions: $filterOptions) {
      id
      entity
      identifier
      parentEntity
      parentIdentifier
      sourceSystem
    }
  }
`;
